import { v4 } from 'uuid';
import { Ref, RefPrefix } from '../types/ref-prefix';

// `Refs` provide the link between 'impact order items' and 'invoice line items'
export const createRef = (type: RefPrefix): Ref => `${type}-${v4()}` as Ref;

// Expected format: `${refPrefix}-${uuid}:${lineItemId}` (lineItemId is optional)
export const extractRef = (ref: Ref): { prefix: RefPrefix; uuid: string; lineItemId: string | undefined } => {
  const [refString, lineItemId] = ref.split(':');
  const [prefix, ...uuid] = refString.split('-');

  return { prefix: prefix as RefPrefix, uuid: uuid.join('-'), lineItemId };
};
